import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { TokenService } from '../token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthPasswordChangeGuard implements CanActivate {

  constructor(
    private tokenService: TokenService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const user = this.tokenService.getDataUser();

    // Check if user needs to change password
    if (user && user.requires_password_change === true) {
      console.log('Password change required - redirecting to force-change-password');
      this.router.navigate(['/force-change-password']);
      return false;
    }

    return true;
  }
}
